import { EntityAccountTypeDto } from 'src/dtos';
import { MTypography } from 'src/lib';
import { Spacing } from 'src/styles';

interface EntityAccountTypeDescriptionProps {
  value?: EntityAccountTypeDto;
}

export const EntityAccountTypeDescription = ({ value }: EntityAccountTypeDescriptionProps) => {
  const getDescription = () => {
    if (value === EntityAccountTypeDto.CCorporation) {
      return (
        <>
          Form of ownership for corporate entities (C-corp). The account signatory must be a corporate officer or
          designated employee and must certify that (s)he has the authority to manage this account on behalf of the
          corporation.
        </>
      );
    }

    if (value === EntityAccountTypeDto.SCorporation) {
      return (
        <>
          Form of ownership for corporate entities (S-corp). The account signatory must be a corporate officer or
          designated employee and must certify that (s)he has the authority to manage this account on behalf of the
          corporation.
        </>
      );
    }

    if (value === EntityAccountTypeDto.LlcCCorporation) {
      return (
        <>
          For legally established limited liability companies filing taxes as a C-Corporation. The account signatory
          must be a member or designated employee and must certify (s)he has the authority to manage this account on
          behalf of the LLC.
        </>
      );
    }

    if (value === EntityAccountTypeDto.LlcSCorporation) {
      return (
        <>
          For legally established limited liability companies filing taxes as a S-Corp. The account signatory must be a
          member or designated employee and must certify (s)he has the authority to manage this account on behalf of the
          LLC.
        </>
      );
    }

    if (value === EntityAccountTypeDto.LlcPartnership) {
      return (
        <>
          For legally established limited liability companies filing taxes as a Partnership. The account signatory must
          be a member or designated employee and must certify (s)he has the authority to manage this account on behalf
          of the LLC.
        </>
      );
    }

    if (value === EntityAccountTypeDto.PersonalTrust) {
      return (
        <>
          A Personal Trust Account permits trustee(s) to manage assets on behalf of its beneficiaries. A copy of the
          Trust Agreement is required to open the account.
        </>
      );
    }

    if (value === EntityAccountTypeDto.BusinessTrust) {
      return (
        <>
          A Business Trust Account permits trustee(s) to manage assets on behalf of its beneficiaries. A copy of the
          Trust Agreement is required to open the account.
        </>
      );
    }

    if (value === EntityAccountTypeDto.Partnership) {
      return <>For legally established partnerships (including limited) of two or more account owners.</>;
    }
  };

  const description = getDescription();

  if (description) {
    return (
      <MTypography variant='subtitle2' inline className={Spacing.mb12} testId='entity-account-type-description'>
        {description}
      </MTypography>
    );
  }

  return null;
};
